<app-panel *ngFor="let sub of subActivities$ | async; let index = index">
  <app-explore-sub-activity
    [index]="index"
    [activity]="sub"
    [shouldHaveMedia]="index === 0"></app-explore-sub-activity>
</app-panel>

<app-add-sub-activity-button (add)="addExploreSubActivity()">
  Add Explore Activity
</app-add-sub-activity-button>
